<template>
    <div id="exchangeVideoVipByLaws">
        <Headers :headersText='headersText'></Headers>
        <!-- banner -->
        <div class="banners">
            <img src="../assets/images/img_16.png" alt="" class="bigImg">
        </div>
        <!-- 说明 -->
        <div class="explain">
            <div>*如果您是首次充值该平台的会员，可使用超值优惠价格；如果不是首次充值，将不能使用超值优惠价格</div>
            <div>*只有当您的余额足够支付兑换会员的费用时才能成功兑换该视频平台会员</div>
            <div>*兑换成功后即刻充值，如有延迟可稍等片刻，一直未充值会员成功请联系客服</div>
            <div>*视频会员所绑定的手机号码必须与本应用所绑定的手机号相同</div>
        </div>
    </div>
</template>

<script>
    import Headers from '../components/headers'
    export default {
        components:{
            Headers
        },
        data() {
            return {
                headersText:'视频会员兑换细则',
            }
        },
        methods: {
            
        },
    }
</script>

<style lang="less" scoped>
    #exchangeVideoVipByLaws{
        width: 100%;
        height: 100%;
        background: #FFFFFF;
        // banner
        .banners{
            width:375px;
            padding-top: 10px;
            background: #F3F3F3;
            .bigImg{
                width: 359px;
                height: 164px;
                margin: 0 8px;
            }
        }
        // 说明
        .explain{
            width:312px;
            font-size:13px;
            font-weight:400;
            color:rgba(17,17,17,1);
            line-height:18px;
            padding: 15px 33px 15px 30px;
            div{
                &:not(:first-of-type){
                    margin-top: 15px;
                }
            }
        }
    }
</style>